import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "public/static/locales";

if (i18n.isInitialized) {
    // A club website initialised the shared instance first, with its German subset
    // (lib/i18n-club). Moving from there into the app keeps that instance and hands it
    // everything else, rather than a second init that would reset it.
    Object.entries(resources).forEach(([language, namespaces]) =>
        Object.entries(namespaces).forEach(([namespace, bundle]) =>
            i18n.addResourceBundle(language, namespace, bundle, true, true)
        )
    );
} else {
    i18n.use(initReactI18next).init({
        resources,
        fallbackLng: "de",
        debug: false, //process.env.NODE_ENV === "development",
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });
}

export default i18n;
